import * as React from 'react';
import { Card } from "react-bootstrap";
import { connect } from 'react-redux';
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile } from '../../actions/profileActions';
import { LIFE_ADD_BENEFICIARY, LIFE_UPDATE_BENEFICIARIES, LIFE_UPDATE_BENEFICIARY_DETAILS, LIFE_UPDATE_POLICY_PAYOUT } from "../../routes/routes";
import { BeneficiaryDetail } from "../Beneficiary/BeneficiaryDetail";
import { BeneficiaryPolicyPayout } from "../Beneficiary/BeneficiaryPolicyPayout";
import './LifeBeneficiaryDetail.css';

class LifeBeneficiaryDetail extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }
        
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.changeEdit = this.changeEdit.bind(this);
        this.handlePolicyPayoutUpdate = this.handlePolicyPayoutUpdate.bind(this);
        this.handleBeneficiaryDetailUpdate = this.handleBeneficiaryDetailUpdate.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    componentDidMount() {
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];
        this.setState({
            selectedBenefit: mainBenefit,
        });
        this.props.dispatchHideProfile();
    }
    
    handleBack() {
        this.handleRedirect(LIFE_UPDATE_BENEFICIARIES);
    }
    
    handleAddBeneficiary() {
        this.handleRedirect(LIFE_ADD_BENEFICIARY);
    }
    
    handlePolicyPayoutUpdate() {
        this.handleRedirect(LIFE_UPDATE_POLICY_PAYOUT);
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }
    
    handleBeneficiaryDetailUpdate() {
        this.handleRedirect(LIFE_UPDATE_BENEFICIARY_DETAILS);
    }

    public render() {

        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        const beneficiary = mainBenefit?.beneficiaries?.filter((beneficiary) => beneficiary.id === this.props.lifePolicy.policy.activeBeneficiaryId)[0];
        return <>
            <Card>
                <Card.Body className="life-beneficiary-detail">
                    { beneficiary &&
                        <BeneficiaryDetail emitHandleUpdate={this.handleBeneficiaryDetailUpdate} beneficiary={beneficiary} />
                    }
                    { this.state.selectedBenefit?.beneficiaries &&
                        <BeneficiaryPolicyPayout emitHandleUpdate={this.handlePolicyPayoutUpdate} beneficiaries={mainBenefit.beneficiaries} />
                    }
                    <div className="row justify-content-end mr-3">
                        <button onClick={this.handleBack} className="btn life-beneficiary-detail__back btn-outline-red">Back</button>
                    </div>
                </Card.Body>
            </Card>
        </>
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeBeneficiaryDetail);